import type { AxiosError } from 'axios';

export const getErrorFromRequest = (request: AxiosError<{ error: string }>): string =>
  request?.response?.data?.error || 'Unknown Error';

export const requestNotificationPermission = Notification.requestPermission;

export const showNotification = async (title: string, options?: NotificationOptions): Promise<Notification | void> => {
  const permission = Notification.permission ?? (await requestNotificationPermission());

  if (permission === 'granted') {
    return Promise.resolve(new Notification(title, options));
  }
};
